import { Link } from "react-router-dom";
const NotFound = () => {
    return (
        <div className="bg-gray-100 text-gray-800 relative min-h-screen">
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">
                <section className="bg-white rounded-lg shadow p-6 w-full text-center">
                    <div className="text-5xl mb-4">🚧</div>

                    <h1 className="text-3xl font-bold text-gray-800 mb-2">
                        Coming Soon
                    </h1>

                    <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                        This page is currently under construction.
                        <br />
                        We’re working hard to launch it very soon.
                    </p>

                    <span className="inline-block bg-indigo-100 text-indigo-600 text-xs font-semibold px-4 py-1 rounded-full mb-6">
                        Launching Shortly
                    </span>

                    <div>
                        <Link
                            to="/flight"
                            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-lg transition"
                        >
                            Go Back Home
                        </Link>
                    </div>
                </section>
            </main>

        </div>
    );
};

export default NotFound;
